module.exports = __webpack_public_path__ + "static/img/img_shu.2c939e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/img_shu.png
// module id = yw9k
// module chunks = 1